export default __webpack_public_path__ + "media/zurb/img/ecommerce/columbia-d13650d860e89c187accacc3d6a752bc.png";